import React from 'react';
import { connect } from 'react-redux';
import { Card, CardBlock, CardTitle , Button} from 'reactstrap';

import ReactTable from "react-table";
import "react-table/react-table.css";
import IconEdit from 'react-icons/lib/md/edit';

import * as actions from '../../actions/departamentos';
import Modal from "./Modal";

class Departamentos extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            modal       : false,
            prospectoid : null,
            title       : "",
        };
        this.toggle 			= this.toggle.bind(this);

    }

   toggle(evt, prospectoid = null, title = "Agregar Departamento")
    {
        let {modal} = this.state;

        this.setState({
            modal       : !modal,
            prospectoid : prospectoid,
            title       : title,
            
        });
    }

    componentDidMount() {

        this.props.get();
    }

    render() {

        return(
            <div className="view">

                <div className="view-header">
                    <header className="title text-white">
                        <h1 className="h4 text-uppercase">Departamentos</h1>
                    </header>
                </div>

                <div className="view-content view-components">
                    <Card>
                        <CardBlock>
                            <ReactTable
                              getTrProps={(state, rowInfo, column) => {
                                  
                                  if(rowInfo === undefined){
                                          
                                          return{

                                          }
                                        }else{
                                           return{
                                            onDoubleClick: (evt)=>this.toggle(evt, rowInfo.original.id, 'Editar Departamento')
                                        } 
                                  
                                    }
                              }}
                              data      = {this.props.departamento.data}
                              className = "-striped -highlight"
                              columns   = {[
                               
                                {Header: 'Departamento', accessor: 'nombre'},
                                {Header: 'Meta', accessor: 'meta'},
                                {Header: 'Comision', accessor: 'comision'},
                                {
                                    Header: 'Controles',
                                    filterable: false,
                                    sortable: false,
                                    Cell: (row) =>
                                    {
                                        return(
                                            <div className="text-right">
                                                <Button
                                                 color="success" 
                                                 className="btn-sm" 
                                                 onClick={(evt)=>this.toggle(evt, row.original.id, 'Editar Departamento')}>
                                                    <IconEdit />
                                                </Button>{' '}
                                                 
                                            </div>
                                        )
                                    }
                                }
                              
                              ]}
                              filterable 
                              defaultPageSize={10} 
                              defaultFilterMethod={(filter, row) => {
                                var patt = new RegExp(filter.value, "i");
                                return row[filter.id].search(patt) > -1 || row[filter.id].search(patt) > -1;
                              }}
                             
                            />
                        </CardBlock>
                    </Card>
                </div>
                 <Modal 
                 open={this.state.modal} 
                 toggle={this.toggle} 
                 title={this.state.title} 
                 prospectoid={this.state.prospectoid}
                />

            </div>
        );
    }

};

function mapStateToProps(state, ownProps) {
    return {
        departamento: state.departamento,
    }
};

export default connect(mapStateToProps, actions)(Departamentos)


// WEBPACK FOOTER //
// ./src/views/departamentos/index.js